import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Explore_top_products.css";
import "swiper/css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import Product_card from "../../common/common_components/product-card/Product_card";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllProducts,
  GetAllTopProducts,
} from "../../../features/admin/products/slice";
import { IDS } from "../../../utils/IDS";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import { encodeId } from "../../../utils/common";

const Explore_top_products = () => {
  // Handler to toggle wishlist
  const toggleWishlist = (id) => {
    // setTopproducts((prev) =>
    //     prev.map((item) =>
    //         item.id === id ? { ...item, inWishlist: !item.inWishlist } : item
    //     )
    // );
  };

  const dispatch = useDispatch();
  const products = useSelector((state) => state.commerce.products.top_products);

  useEffect(() => {
    dispatch(GetAllTopProducts());
  }, [dispatch]);

  return (
    <section className="Explore_top_products">
      <div className="container-lg">
        <Common_Title_1
          subText={"Top Products"}
          linktext={"See all"}
          link={"/all-products"}
        />

        <div className="slider_sec">
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: { slidesPerView: 1.5, spaceBetween: 10 },
              575: { slidesPerView: 3, spaceBetween: 10 },
              768: { slidesPerView: 4, spaceBetween: 10 },
              1200: { slidesPerView: 5, spaceBetween: 10 },
            }}
            className="mySwiper pb-5"
          >
            {products?.map((data) => (
              <SwiperSlide key={data.id}>
                <Product_card
                  average_rating={data.average_rating}
                  id={data.id}
                  image={IDS.IMG_URL + data.image}
                  name={data.name}
                  subname={`(${data?.p_category?.name})`}
                  oldprise={data.mrp}
                  prise={data.price}
                  link={`/product-details/${encodeId(data.id)}`}
                  inWishlist={data.inWishlist}
                  onRemove={() => toggleWishlist(data.id)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Explore_top_products;
